// TODO: Delete unused events
const ANALYTICS_EVENTS = {
  FIELD_ACTION: 'field_action',
  FIELD_CLICK: 'field_click',
  PHOTO_EDIT_ITEM_ACTION: 'photo_edit_item_action',
  POPUP_OPEN: 'popup_open',
  POPUP_ACTION: 'popup_action',
  BUTTON_CLICK: 'button_click',
  SEARCH_RESULT_SEEN: 'search_result_seen',
  SEARCH_CLICK: 'search_click',
  FILTER_CLICK: 'filter_click',
  SEARCH_ICON_CLICK: 'search_icon_click',
  FILTER_ITEM_CLICK: 'filter_item_click',
  UPLOAD_DONE: 'upload_done',
  HOME_CLICK: 'home_click',
  PHOTO_EDIT_ITEM_OPEN: 'photo_edit_item_open',
  CREATE_FLOW_SECTION_CLICK: 'create_flow_section_click',
  CREATE_FLOW_ITEM_CLICK: 'create_flow_item_click',
  EXPORT_POPUP_ACTION: 'export_popup_action',
  OBJECT_EXPORT: 'object_export',
  BATCH_EXPORT: 'batch_export',
  OBJECT_EXPORT_DOWNLOAD: 'object_export_download',
  OBJECT_EXPORT_SHARE: 'object_export_share',
  PAY_AND_DOWNLOAD_POPUP: 'pay_and_donwload_popup',
  EXPORT_FINISHED: 'export_finished',
  ONE_TIME_PURCHASE_SEEN: 'one_time_purchase_seen',
  HELP_CLICK: 'help_click',
  BUTTON_ITEM_CLICK: 'button_item_click',
  UPLOAD_COMPLETE: 'upload_complete',
  EFFECT_TRY: 'effect_try',
  KEYBOARD_SHORTCUT: 'keyboard_shortcut',
  SCREEN_OPEN: 'screen_open',
  EFFECT_APPLY: 'effect_apply',
  EXPORT_POPUP_OPEN: 'export_popup_open',
  PURCHASE_DONE_POPUP: 'purchase_done_popup',
  SUBSCRIPTION_DONE: 'subscription_done',
  DROP_DOWN_MENU_CLICK: 'drop_down_menu_click',
  DROP_DOWN_ITEM_CLICK: 'drop_down_item_click',
  START_FREE_TRIAL_POPUP: 'start_free_trial_popup',
  SUBSCRIPTION_OFFER_OPEN: 'subscription_offer_open',
  PAGE_CLICK: 'page_click',
  CHOOSER_CLICK: 'chooser_click',
  CREATE_FLOW_OPEN: 'create_flow_open',
  PHOTO_EDITOR_OPEN: 'photo_editor_open',
  ITEM_CLICK: 'item_click',
  PHOTO_EDITOR_CLOSE: 'photo_editor_close',
  CATEGORY_OPEN: 'category_open',
  SUBCATEGORY_OPEN: 'subcategory_open',
  OBJECT_APPLY: 'object_apply',
  OBJECT_CANCEL: 'object_cancel',
  RIGHT_CLICK_ACTION: 'right_click_action',
  TOOL_SETTINGS_CLICK: 'tool_setting_click',
  ALIGNMENT_SETTING_TRY: 'alignment_setting_try',
  FLIP_ROTATE_SETTING_TRY: 'flip_rotate_setting_try',
  OBJECT_TOP_NAVIGATION_CLICK: 'object_top_navigation_click',
  CHOOSER_SUBCATEGORY_OPEN: 'chooser_subcategory_open',
  HORIZONTAL_SCROLL: 'horizontal_scroll',
  SHADOW_PRESET_CLICK: 'shadow_preset_click',
  CONTENT_TRY: 'content_try',
  ERASER: {
    OPEN: 'photo_edit_item_open',
    SCREEN_ACTION: 'tool_eraser_screen_action',
    AUTO_RESULT_SEEN: 'tool_eraser_auto_result_seen',
    ERASER_COMPLATE: 'tool_eraser_complete',
  },
  CONTEXT_MENU: {
    OPEN: 'context_menu_open',
    ACTION: 'context_menu_action',
    CANCEL: 'context_menu_cancel',
    RIGHT_CLICK_ACTION: 'right_click_action',
  },
  FILES_OPEN: 'files_open',
  FILES_CLICK: 'files_click',
  OBJECT_CLICK: 'object_click',
  OBJECT_TRY: 'object_try',
  CHOOSERS_CATEGORY_OPEN: 'chooser_category_open',
  CHOOSERS_SUBCATEGORY_OPEN: 'chooser_subcategory_open',
  SAVE_PROJECT_OBJECT_CREATE: 'save_project_object_create',
  SAVE_PROJECT_OBJECT_DELETE: 'save_project_object_delete',
  EMPTY_STATE_VIEW_OPEN: 'empty_state_view_open',
  TOAST_VIEW: 'toast_view',
  AI_ENHANCE_OPEN: 'ai_enhance_open',
  AI_ENHANCE_TRY: 'ai_enhance_try',
  AI_ENHANCE_RESULT_SEEN: 'ai_enhance_result_seen',
  AI_ENHANCE_COMPLETE: 'ai_enhance_complete',
  FILES_TAB_OPEN: 'files_tab_open',
  TOOLTIP_VIEW: 'tooltip_view',
  OBJECT_ACTION: 'object_action',
  CHECKOUT_SCREEN_OPEN: 'checkout_screen_open',
  REGISTRATION_OPEN: 'registration_open',

  // Miniapp events
  MINIAPP_OPEN: 'miniapp_open',
  MINIAPP_CLOSE: 'miniapp_close',
  MINIAPP_READY: 'miniapp_ready',
  MINIAPP_LOAD: 'miniapp_load',
  MINIAPP_ERROR: 'miniapp_error',
};

export default ANALYTICS_EVENTS;
